import React from "react";
import { withRouter } from "react-router-dom";

// Component that automatically scrolls to the top of the page when the route changes
// This ensures users start at the top when navigating to a new page
class ScrollToTop extends React.Component {
  // Check if the route has changed after component updates
  componentDidUpdate(prevProps) {
    const { location } = this.props;
    const prevLocation = prevProps.location;

    // If the pathname (route) hasn't changed, nothing to do.
    if (location.pathname === prevLocation.pathname) return;

    // A profile modal opening or closing changes the pathname (e.g.
    // /members -> /members/john or back) while the roster underneath stays
    // mounted at its scroll position — neither transition should scroll.
    const prevBackground = prevLocation.state && prevLocation.state.background;
    const background = location.state && location.state.background;
    if (prevBackground || background) return;

    // Scroll window to top (x: 0, y: 0)
    window.scrollTo(0, 0);
  }

  // This component doesn't render anything visible
  render() {
    return null;
  }
}

// Export component wrapped with withRouter to access location prop
export default withRouter(ScrollToTop);